module.exports = __webpack_public_path__ + "img/linkedin-icon.bc51666c.svg";